
// Import Libraries
import ReactDOM from 'react-dom';

// -----------------------------------------------------------
//  DeliveryOptionOpenableMixin
// -----------------------------------------------------------
const DeliveryOptionOpenableMixin = {
  clickAction() {
    this.props.handleOpen(ReactDOM.findDOMNode(this), this.props.disabled);
  },
};

export default DeliveryOptionOpenableMixin;
